import React from 'react';
import { Minimize2 } from 'lucide-react';
import SCurveChart from '../SCurveChart';
import {ProjectStatusChart} from '../Charts';
import CriticalPathCard from '../CriticalPathCard';
import FinanceSummaryCharts from '../FinanceSummaryCharts';

const FullScreenChart = ({ 
  chartId, 
  onClose, 
  sCurveData, 
  selectedYear, 
  selectedProject, 
  selectedShip 
}) => {
  const chartOptions = [
    { id: 'sCurve', label: 'S-Curve Chart' },
    { id: 'projectStatus', label: 'Project Status' },
    { id: 'criticalPath', label: 'Critical Path Analysis' },
    { id: 'financialOverview', label: 'Financial Overview' }
  ];

  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col">
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-xl font-semibold">
          {chartOptions.find(opt => opt.id === chartId)?.label}
        </h2>
        <div className="flex items-center space-x-4">
          <button
            onClick={onClose}
            className="p-1.5 rounded hover:bg-gray-100"
          >
            <Minimize2 size={16} className="text-gray-600" />
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-auto p-4">
        {chartId === 'sCurve' && (
          <SCurveChart 
            data={sCurveData} 
            selectedYear={selectedYear} 
            selectedProject={selectedProject} 
            selectedShip={selectedShip} 
          />
        )}
        {chartId === 'projectStatus' && (
          <ProjectStatusChart
            selectedProject={selectedProject}
            selectedYear={selectedYear}
            selectedShip={selectedShip}
          />
        )}
        {chartId === 'criticalPath' && (
          <CriticalPathCard 
            selectedProject={selectedProject} 
            selectedShip={selectedShip} 
          />
        )}
        {chartId === 'financialOverview' && (
          <FinanceSummaryCharts
            selectedProject={selectedProject}
            selectedShip={selectedShip}
          />
        )}
      </div>
    </div>
  );
};

export default FullScreenChart;